import * as user from "../api/user";
import { call, fork, put, take, takeLatest } from "redux-saga/effects";
import { NavLink, useNavigate } from "react-router-dom";
import userActions from "../slices/userSlice";
import { ErrorLogic } from "../../components/hooks/authFunc";

function* requestFetchCheckPassword(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestCheckPassword, params);
  if (response) {
    yield put(userActions.actions.fetchCheckPasswordSuccess(response));
  } else {
    yield put(userActions.actions.fetchCheckPasswordFailure(err));
  }
}

//1:1 문의하기 등록
function* requestFetchInquiryAdd(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestInquiryAdd, params);

  if (response) {
    yield put(userActions.actions.fetchInquiryAddSuccess(response));
  } else {
    yield put(userActions.actions.fetchInquiryAddFailure(err));
    yield ErrorLogic(err.response);
  }
}

//1:1 문의하기 등록
function* requestFetchInquiryList(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestInquiryList, params);

  if (response) {
    yield put(userActions.actions.fetchInquiryListSuccess(response));
  } else {
    yield put(userActions.actions.fetchInquiryListFailure(err));
    yield ErrorLogic(err.response);
  }
}

//유저 정보 조회
function* requestFetchUserLookup(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestUserLookup, params);
  if (response) {
    yield put(userActions.actions.fetchUserLookupSuccess(response));
  } else {
    yield put(userActions.actions.fetchUserLookupFailure(err));
    yield ErrorLogic(err.response);
  }
}

//비밀번호 변경
function* requestFetchChangeUserPassword(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestChangeUserPassword, params);
  if (response) {
    yield put(userActions.actions.fetchChangeUserPasswordSuccess(response));
  } else {
    yield put(userActions.actions.fetchChangeUserPasswordFailure(err));
    yield ErrorLogic(err.response);
  }
}

//이메일 변경(요청)
function* requestFetchChangeUserEmail(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestChangeUserEmail, params);
  if (response) {
    yield put(userActions.actions.fetchChangeUserEmailSuccess(response));
  } else {
    yield put(userActions.actions.fetchChangeUserEmailFailure(err));
    yield ErrorLogic(err.response);
  }
}

//이름 변경
function* requestFetchChangeUserName(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestChangeUserName, params);
  if (response) {
    yield put(userActions.actions.fetchChangeUserNameSuccess(response));
  } else {
    yield put(userActions.actions.fetchChangeUserNameFailure(err));
    yield ErrorLogic(err.response);
  }
}

//핸드폰번호 변경
function* requestFetchChangeUserPhone(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestChangeUserPhone, params);
  if (response) {
    yield put(userActions.actions.fetchChangeUserPhoneSuccess(response));
  } else {
    yield put(userActions.actions.fetchChangeUserPhoneFailure(err));
    yield ErrorLogic(err.response);
  }
}

//나의 포인트 거래내역
function* requestFetchMyPointHistory(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestMyPointHistory, params);
  if (response) {
    yield put(userActions.actions.fetchMyPointHistorySuccess(response));
  } else {
    yield put(userActions.actions.fetchMyPointHistoryFailure(err));
    yield ErrorLogic(err.response);
  }
}

//나의 소멸예정 포인트
function* requestFetchMyExpirationPoint(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestMyExpirationPoint, params);
  if (response) {
    yield put(userActions.actions.fetchMyExpirationPointSuccess(response));
  } else {
    yield put(userActions.actions.fetchMyExpirationPointFailure(err));
    yield ErrorLogic(err.response);
  }
}

//회원 설정 조회
function* requestFetchUserSetting(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestUserSetting, params);
  if (response) {
    yield put(userActions.actions.fetchUserSettingSuccess(response));
  } else {
    yield put(userActions.actions.fetchUserSettingFailure(err));
    yield ErrorLogic(err.response);
  }
}

//회원 설정
function* requestFetchUserSettingUpdate(payload) {
  const params = payload.payload;
  const { response, err } = yield call(user.requestUserSettingUpdate, params);
  if (response) {
    yield put(userActions.actions.fetchUserSettingUpdateSuccess(response));
  } else {
    yield put(userActions.actions.fetchUserSettingUpdateFailure(err));
    yield ErrorLogic(err.response);
  }
}

export default function* watchUser() {
  yield takeLatest(
    userActions.actions.fetchCheckPassword,
    requestFetchCheckPassword
  );
  yield takeLatest(userActions.actions.fetchInquiryAdd, requestFetchInquiryAdd);
  yield takeLatest(
    userActions.actions.fetchInquiryList,
    requestFetchInquiryList
  );
  yield takeLatest(userActions.actions.fetchUserLookup, requestFetchUserLookup);
  yield takeLatest(
    userActions.actions.fetchChangeUserPassword,
    requestFetchChangeUserPassword
  );
  yield takeLatest(
    userActions.actions.fetchChangeUserEmail,
    requestFetchChangeUserEmail
  );
  yield takeLatest(
    userActions.actions.fetchChangeUserName,
    requestFetchChangeUserName
  );
  yield takeLatest(
    userActions.actions.fetchChangeUserPhone,
    requestFetchChangeUserPhone
  );
  yield takeLatest(
    userActions.actions.fetchMyPointHistory,
    requestFetchMyPointHistory
  );
  yield takeLatest(
    userActions.actions.fetchMyExpirationPoint,
    requestFetchMyExpirationPoint
  );
  yield takeLatest(
    userActions.actions.fetchUserSetting,
    requestFetchUserSetting
  );
  yield takeLatest(
    userActions.actions.fetchUserSettingUpdate,
    requestFetchUserSettingUpdate
  );
}
